"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatFieldMappingTag = (value) => `{{${value}}}`;
exports.default = formatFieldMappingTag;
